import "./space.css";
import { Space } from './space';
export default Space;